/**
 * Dynamically positions images within a container based on data attributes
 * @param {string} containerId - The ID of the container div
 */
export const initializeDynamicImages = (containerId) => {
  const container = document.getElementById(containerId);
  if (!container) return;

  // Get data attributes
  const imageCount = parseInt(
    container.getAttribute("data-image-count") || "0"
  );
  const imageHeight = parseInt(
    container.getAttribute("data-image-height") || "100"
  );
  const imageWidth = parseInt(
    container.getAttribute("data-image-width") || "100"
  );

  // Get container dimensions
  const containerWidth = container.offsetWidth;
  const containerHeight = container.offsetHeight;

  // Clear existing content
  container.innerHTML = "";

  // Function to check if a position overlaps with existing images
  const isOverlapping = (left, top, positions) => {
    const margin = 10; // Minimum space between images
    for (const pos of positions) {
      if (
        left < pos.left + imageWidth + margin &&
        left + imageWidth + margin > pos.left &&
        top < pos.top + imageHeight + margin &&
        top + imageHeight + margin > pos.top
      ) {
        return true;
      }
    }
    return false;
  };

  // Store positions of placed images
  const positions = [];

  // Create and position images
  for (let i = 0; i < imageCount; i++) {
    const img = document.createElement("img");
    img.src = "images/logo8.png"; // Replace with your image path
    img.style.position = "absolute";
    img.style.width = `${imageWidth}px`;
    img.style.height = `${imageHeight}px`;
    img.alt = `Image ${i + 1}`;

    // Try to find a non-overlapping position (max 50 attempts)
    let left, top;
    let attempts = 0;
    const maxAttempts = 50;

    do {
      left = Math.random() * (containerWidth - imageWidth);
      top = Math.random() * (containerHeight - imageHeight);
      attempts++;
    } while (isOverlapping(left, top, positions) && attempts < maxAttempts);

    // Store the position
    positions.push({ left, top });

    // Apply position with smooth animation
    img.style.left = `${left}px`;
    img.style.top = `${top}px`;

    // Add some random rotation for visual interest
    const rotation = Math.random() * 20 - 10; // Random rotation between -10 and 10 degrees
    img.style.transform = `rotate(${rotation}deg)`;

    container.appendChild(img);
  }

  // Add necessary container styles
  container.style.position = "relative";
};
